import { Injectable } from '@angular/core';
import { CrudService } from '@appstrax/services/database';
import { HistoryEntry } from '@models';

@Injectable({ providedIn: 'root' })
export class HistoryEntryService extends CrudService<HistoryEntry> {
  constructor() {
    super('history-entries', HistoryEntry);
  }
}

